module.exports = __webpack_public_path__ + "img/text_01.abf10517.png";